import type { TestPackageActivityHistoryRow } from './servicesLib';

type SAHistoryLookupRow = {
    DisciplineID?: number | null;
    MatchValue?: string | null;
    ROCLabelShort?: string | null;
    RecordNumber?: number | null;
};

export function getMatchingTestPackageHistory(
    row: SAHistoryLookupRow,
    historyRows: TestPackageActivityHistoryRow[],
): TestPackageActivityHistoryRow[] | null {
    const testPackage = row.MatchValue?.trim();
    if (!testPackage || row.DisciplineID == null) return null;

    return historyRows.filter(history =>
        history.DisciplineID === row.DisciplineID
        && history.TestPackage === testPackage
        && history.ROCLabelShort === row.ROCLabelShort
        && history.RecordNumber !== row.RecordNumber
    );
}

export function getPendingSAPercent(historyRows: TestPackageActivityHistoryRow[]): number {
    return historyRows.reduce((total, history) => {
        if (history.QueID !== 1 && history.QueID !== 2) return total;
        return total + Number(history.Percent ?? 0);
    }, 0);
}
